var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.75 17C24.1642 17 24.5 17.3358 24.5 17.75C24.5 20.7441 20.8656 23 16.5 23C12.1344 23 8.5 20.7441 8.5 17.75C8.5 17.3358 8.83579 17 9.25 17C9.66421 17 10 17.3358 10 17.75C10 19.7264 12.8574 21.5 16.5 21.5C20.1426 21.5 23 19.7264 23 17.75L23.0068 17.6484C23.0565 17.2824 23.3703 17 23.75 17ZM26.75 15C27.1297 15 27.4435 15.2824 27.4932 15.6484L27.5 15.75V22.25C27.5 22.6642 27.1642 23 26.75 23C26.3703 23 26.0565 22.7176 26.0068 22.3516L26 22.25V15.75C26 15.3358 26.3358 15 26.75 15ZM16.165 5.3291C16.376 5.22379 16.624 5.22379 16.835 5.3291L28.835 11.3291C29.3877 11.6055 29.3877 12.3945 28.835 12.6709L16.835 18.6709C16.624 18.7762 16.376 18.7762 16.165 18.6709L4.16504 12.6709C3.61225 12.3945 3.61225 11.6055 4.16504 11.3291L16.165 5.3291ZM6.17578 12L16.5 17.1611L26.8232 12L16.5 6.83789L6.17578 12Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.706e833b26da0208e161f6412fd72b48.svg";
export { ForwardRef as ReactComponent };